export const types = {
    SHOW_MODAL: "SHOW_MODAL",
    HIDE_MODAL: "HIDE_MODAL",

    CONFIRM_YES: "CONFIRM_YES",
    CONFIRM_NO: "CONFIRM_NO",
};
